import Alpine from 'alpinejs'

const introductionManager = (initialData = {}) => ({
  existingIntroductionsCount: initialData.existingIntroductionsCount || 0,
  existingIntroductions: initialData.existingIntroductions || [],
  newIntroductions: [],
  removedIntroductionIds: [],
  _savedPosition: null,

  nextPosition() {
    const existingActiveCount = this.existingIntroductionsCount - this.removedIntroductionIds.length
    return existingActiveCount + this.newIntroductions.length + 1
  },

  swapExistingIntroductionPosition(introId, newPosition) {
    const intro = this.existingIntroductions.find(i => i.id === introId)
    if (!intro) return

    const oldPosition = intro.position
    newPosition = parseInt(newPosition)
    if (oldPosition === newPosition || isNaN(newPosition)) return

    const conflict = this._findConflict(newPosition, { existingId: introId })

    intro.position = newPosition

    if (conflict) {
      this._setConflictPosition(conflict, oldPosition)
    }
  },

  swapNewIntroductionPosition(tempId, oldPosition) {
    const intro = this.newIntroductions.find(i => i.tempId === tempId)
    if (!intro) return

    const newPosition = intro.position
    if (oldPosition === newPosition) return

    const conflict = this._findConflict(newPosition, { newTempId: tempId })

    if (conflict) {
      this._setConflictPosition(conflict, oldPosition)
    }
  },

  _findConflict(position, exclude) {
    const existingConflict = this.existingIntroductions.find(i =>
      i.position === position &&
      i.id !== exclude.existingId &&
      !this.removedIntroductionIds.includes(String(i.id))
    )
    if (existingConflict) return { type: 'existing', intro: existingConflict }

    const newConflict = this.newIntroductions.find(i =>
      i.position === position && i.tempId !== exclude.newTempId
    )
    if (newConflict) return { type: 'new', intro: newConflict }

    return null
  },

  _setConflictPosition(conflict, position) {
    conflict.intro.position = position
  },

  _reindexPositions() {
    const activeExisting = this.existingIntroductions
      .filter(i => !this.removedIntroductionIds.includes(String(i.id)))
    const all = [
      ...activeExisting.map(i => ({ ref: i, type: 'existing' })),
      ...this.newIntroductions.map(i => ({ ref: i, type: 'new' }))
    ]
    all.sort((a, b) => a.ref.position - b.ref.position)
    all.forEach((item, i) => {
      item.ref.position = i + 1
    })
  },

  addIntroduction() {
    this.newIntroductions.push({
      tempId: Date.now(),
      position: this.nextPosition(),
      title: '',
      content: ''
    })
    this._reindexPositions()
  },

  removeNewIntroduction(tempId) {
    this.newIntroductions = this.newIntroductions.filter(i => i.tempId !== tempId)
    this._reindexPositions()
  },

  markExistingIntroductionForRemoval(introductionId) {
    this.removedIntroductionIds.push(introductionId)
    this._reindexPositions()
  },

  isExistingIntroductionRemoved(introductionId) {
    return this.removedIntroductionIds.includes(introductionId)
  },

  existingIntroductionOrder(introId) {
    const intro = this.existingIntroductions.find(i => i.id === introId)
    return intro ? intro.position : 0
  }
})

Alpine.data('introductionManager', introductionManager)
export default introductionManager
